import {
  isRejectedWithValue,
  unwrapResult,
  type MiddlewareAPI,
  type Middleware,
} from "@reduxjs/toolkit";
import { registrationApiSlice } from "./api/registration";
import { calculateSignalSummary } from "@timeedit/registration-shared";
import { identifyRTKErrorLocation } from "../utils/errors";
import { logger } from "@timeedit/registration-components";
import { setSignals } from "./slices/computed";

/**
 * Logs query errors.
 */

export const rtkErrorMiddleware: Middleware =
  (_: MiddlewareAPI) => (next) => (action) => {
    if (isRejectedWithValue(action) && action?.error) {
      logger.error(
        `[rtk query][${identifyRTKErrorLocation(action)}][rejection]: ${
          "data" in action.error
            ? (action.error.data as { message: string }).message
            : action.error.message
        }`,
        action
      );
    }

    return next(action);
  };

/**
 * Calculates the signals (ISSUE, PENDING, OK), and a summary of those, on each
 * fullfilled catalog fetch request.
 */

export const calculateSignalsMiddleware: Middleware =
  ({ dispatch }: MiddlewareAPI) =>
  (next) =>
  (action) => {
    if (
      registrationApiSlice.endpoints.fetchRegistration.matchFulfilled(action)
    ) {
      const registration = unwrapResult(action);
      dispatch(
        setSignals({
          summary: calculateSignalSummary({
            registration,
          }),
        })
      );
    }

    return next(action);
  };
